<template>
  <div class="last-news-content-type">
    <div class="last-news-title">{{$t('lastNews.news')}}</div>
    <div class="last-news-list">
      <VueSlickCarousel v-bind="settings" v-if="newsList.length">
        <template #prevArrow="">
          <carousel-arrow :rotate="true" />
        </template>
        <template #nextArrow>
          <carousel-arrow />
        </template>
        <div
          v-for="(news, index) in newsList"
          :key="index"
          class="last-news-item"
        >
          <router-link
            class="text-decoration-none"
            :to="{
              name: 'page',
              params: {
                urlKey: model.metadata.newsDetailsUrlKey,
                p1: news.urlKey,
              },
            }"
          >
            <display-image
              class="last-news-item-img"
              gradient="rgba(32, 40, 75,0.85), rgba(32, 40, 75, 0.85)"
              style="margin: 1rem"
              aspect="1"
              :maxWidth="600"
              :imageId="news.imageId"
            >
              <div class="last-news-item-title">{{ news.title }}</div>
            </display-image>
          </router-link>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import dataAccess from '../../../services/service.data-access'
import DisplayImage from '../../_shared/DisplayImage.vue'
import CarouselArrow from '../../_shared/svg/CarouselArrow.vue'

export default {
  name: 'LastNews',
  components: {
    VueSlickCarousel,
    DisplayImage,
    CarouselArrow
  },
  props: ['model'],
  data: () => ({ carousel: null, newsList: [] }),
  computed: {
    settings: function() {
      return {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        lazyLoad: 'progressive',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false
            }
          }
        ]
      }
    }
  },
  async created() {
    var news = await dataAccess.getLastNews()
    this.newsList = news
  }
}
</script>
<style lang="scss">
.slick-arrow::before {
  color: black;
}
.last-news-content-type {
  .last-news-title {
    font-size: 3.4rem;
    font-weight: bold;
  }

  .last-news-item {
    .last-news-item-img {
      margin: 1rem;
    }
    .last-news-item-title {
      font-size: 2.2rem;
      font-weight: 500;
      color: white;
      margin: 2rem;
    }
  }
}
</style>
